export const formatPhone = (phone, ddi) => {
  if (!phone) return "";
  if (!ddi) ddi = "55";
  let _phone = phone.replace(/\D/g, "");
  let initials = _phone.substring(0, 2);
  if (initials === ddi) return _phone;
  if (initials === "+" + ddi.substring(0, 1)) return _phone;
  if (initials == ddi.replace(/\D/g, ""))
    _phone = _phone.substring(2, _phone.length);

  if (_phone.length >= 10 || _phone.length >= 11) {
    _phone = ddi.toString() + _phone.toString();
  }

  return _phone;
};
export const reversePhone = (phone, ddi) => {
  if (!phone) return "";
  if (!ddi) ddi = "55";
  let _phone = phone.replace(/\D/g, "");
  let initials = _phone.substring(0, 2);
  if (initials === ddi) return _phone.substring(2, _phone.length);
  return _phone;
};

export const clearPhone = (value) => {
  if (!value) return "";
  value = value.replace(/[^\d]/g, "");
  if (value.length >= 13 && value.substring(0, 2) == "55")
    return value.substring(2, value.length);
  return value;
};
